module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_maedori@2x-c51fa5ba545c6b6afeada959e31df8e1.webp";